import { createDecorator } from '../../instantiation/common/instantiation.js';
const IUndoRedoService = ( createDecorator('undoRedoService'));
export { IUndoRedoService };
